export const showBadgeOnFavicon = () => {
  const favicons = document.querySelectorAll('.favicon');

  favicons.forEach(favicon => {
    const newFileName = `/favicon-badge-${favicon.sizes[[0]]}.png`;
    favicon.href = newFileName;
  });
};

export const initFaviconSwitcher = () => {
  const favicons = document.querySelectorAll('.favicon');

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      favicons.forEach(favicon => {
        const oldFileName = `/favicon-${favicon.sizes[[0]]}.png`;
        favicon.href = oldFileName;
      });
      // Stop blinking title when user returns to tab
      stopBlinkingTitle();
    }
  });
};

// Browser tab title blinking for notifications
let titleBlinkInterval = null;
let originalTitle = document.title;

export const startBlinkingTitle = (newMessage = 'Nova Mensagem!') => {
  if (titleBlinkInterval) return; // Already blinking
  
  originalTitle = document.title;
  let isAlternate = false;
  
  titleBlinkInterval = setInterval(() => {
    document.title = isAlternate ? originalTitle : `🔔 ${newMessage}`;
    isAlternate = !isAlternate;
  }, 1000); // Blink every second
};

export const stopBlinkingTitle = () => {
  if (titleBlinkInterval) {
    clearInterval(titleBlinkInterval);
    titleBlinkInterval = null;
    document.title = originalTitle;
  }
};

export const updateUnreadCount = (count) => {
  if (count > 0) {
    startBlinkingTitle(`(${count}) Nova${count > 1 ? 's' : ''} Mensagem${count > 1 ? 's' : ''}!`);
    showBadgeOnFavicon();
  } else {
    stopBlinkingTitle();
  }
};
